import type { ComparisonRow, SimpleCard } from '../types/content';

export const statsData: SimpleCard[] = [
  { title: '+200', copy: 'Monitores activos' },
  { title: '250+', copy: 'Páginas de contenido' },
  { title: '+4h', copy: 'Ahorradas por semana' },
  { title: '5', copy: 'Tomos especializados' }
];

export interface TransformationBlock {
  label: string;
  before: string;
  after: string;
  stat?: string;
}

export const transformationBlocks: TransformationBlock[] = [
  {
    label: 'Planificación',
    before: 'Domingo por la noche buscando ejercicios que no sabes si van a funcionar el lunes.',
    after: 'Abres la ficha, ves el objetivo y entras a pista en 2 minutos.',
    stat: '−90% tiempo'
  },
  {
    label: 'Seguridad',
    before: 'Inseguridad con grupos de niveles mixtos. No sabes si el ejercicio es correcto para ellos.',
    after: 'Progresiones claras por nivel. Sabes exactamente qué trabajar y en qué orden.'
  },
  {
    label: 'Variedad',
    before: 'Los mismos 10 ejercicios de siempre. Los alumnos los conocen de memoria.',
    after: 'Ejercicios organizados por objetivo. Defensa, ataque, táctica y más, todo conectado.'
  },
  {
    label: 'Energía',
    before: 'Llegas mentalmente cansado después de organizarlo todo desde cero esa mañana.',
    after: 'Llegas con energía y con el plan claro para centrarte en tus alumnos desde el primer minuto.'
  }
];

export interface MethodStep {
  number: string;
  title: string;
  copy: string;
}

export const methodSteps: MethodStep[] = [
  {
    number: '01',
    title: 'Abre',
    copy: 'Elige qué quieres trabajar: defensa, ataque, táctica o planificación. Tienes todo organizado por objetivo.'
  },
  {
    number: '02',
    title: 'Consulta',
    copy: 'Lee la ficha. Ejercicio, progresión, corrección y qué viene después. Todo en una página clara.'
  },
  {
    number: '03',
    title: 'Entra a pista',
    copy: 'Llévalo directamente a clase. Sin improvisar. Sin llegar preguntándote qué vas a hacer hoy.'
  }
];

export interface ForWhoScene {
  number: string;
  title: string;
  copy: string;
}

export const forWhoScenes: ForWhoScene[] = [
  {
    number: '01',
    title: 'Improvisación constante',
    copy: 'Llegas a pista sin saber exactamente qué vas a trabajar. Improvisar sobre la marcha en lugar de seguir una progresión pensada de antemano.'
  },
  {
    number: '02',
    title: 'Alumnos que no progresan',
    copy: 'No tienes una secuencia clara de fundamento en fundamento. Al final del mes no sabes si han mejorado realmente.'
  },
  {
    number: '03',
    title: 'Siempre los mismos ejercicios',
    copy: 'Repites lo mismo porque no tienes más material organizado. Los alumnos llegan a clase sin ilusión por saber qué toca hoy.'
  },
  {
    number: '04',
    title: 'Grupos con niveles mixtos',
    copy: 'Tienes jugadores muy distintos en la misma pista y no sabes cómo dar un ejercicio que funcione para todos sin dejar a nadie atrás.'
  },
  {
    number: '05',
    title: 'Inseguridad al corregir',
    copy: 'Te cuesta saber exactamente qué decirle al alumno para que mejore su bandeja o su salida de pared sin soltar un discurso largo.'
  },
  {
    number: '06',
    title: 'Quieres ser visto como profesional',
    copy: 'Buscas ofrecer clases con criterio metodológico real, una progresión clara y que tus alumnos lo noten desde el primer día.'
  }
];

export const insideBenefits: string[] = [
  'Ejercicios explicados',
  'Progresiones organizadas',
  'Sesiones estructuradas',
  'Aplicación directa en pista'
];

export const insideScreenshots: string[] = [
  'Ficha 05 — Salida de Pared de Fondo',
  'Semáforo de Errores — Base de la Bandeja',
  'Ficha 14 — Regla de los 3 Golpes',
  'La Volea de Definición',
  'Ficha 12 — Remate con Decisión',
  'Ficha 06 — Pared Lateral y Doble Pared',
  'Las 8 Zonas Críticas del Pádel'
];

export const comparisonRows: ComparisonRow[] = [
  { feature: '5 Tomos especializados', base: true, kit: true },
  { feature: '250+ páginas de contenido', base: true, kit: true },
  { feature: 'Fichas de Pista (25 fichas)', base: true, kit: true },
  { feature: 'Radar del Alumno', base: true, kit: true },
  { feature: 'Semáforo de Correcciones Rápidas', base: true, kit: true },
  { feature: 'Planificador 30 Días', base: true, kit: true },
  { feature: 'Vuelta a Pista', base: true, kit: true },
  { feature: 'Mapa de Pista — 50 esquemas visuales', base: false, kit: true },
  { feature: 'Programador 12 Meses', base: false, kit: true }
];
